<script>
import {get} from "@/client/utilities/Object";

export default {
    name: 'SectionAutocomplete',
    inheritAttrs: false,
    props: [
        'items', 'loading', 'value', 'rules', 'rack', 'disabled'
    ],
    computed: {
        inputListeners: function () {
            let vm = this;
            return Object.assign({},
                this.$listeners,
                {
                    input: function (val) {
                        vm.$emit('input', val);
                    }
                }
            )
        },
        sections: function () {

            if(!this.items) {
                return get(this.rack, 'sections', []);
            }

            return this.items;
        }
    },
}
</script>

<template>
    <VAutocomplete
            outlined
            v-on="inputListeners"
            v-bind:value="value"
            :items="sections"
            v-bind:rules="rules"
            v-bind:loading="loading"
            v-bind:disabled="disabled"
            item-text="section"
            item-value="id"
            label="Section"
            return-object
            clearable
    />
</template>

<style scoped>

</style>